import { z } from "zod";

const validationSchema = z.object({
  message: z.string().optional(),
  employeeType: z.enum(["REGULAR", "CONSULTANT", "SQELABS"]),
  consultantType: z.string().nullish(),
  recipientType: z.string().nullish(),
  onboardingFor: z.enum(["INDIA", "US"]).optional(),
  onboardingReferenceId: z.string().nullish().transform((value) => value ?? undefined),
  valid: z.boolean().optional(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  email: z.string().email().optional(),
});

export type OnboardingDestination = "regular-india" | "regular-us" | "consultant-india" | "consultant-us" | "consultant-agency-us" | "agency";

export function resolveOnboardingDestination(body: unknown, regularUsLink = false) {
  const parsed = validationSchema.safeParse(body);
  if (!parsed.success) throw new Error("The verification response is missing valid onboarding details. Please contact your onboarding coordinator.");
  const details = parsed.data;
  if (details.valid === false) throw new Error("This onboarding invitation could not be verified. Please check your invitation and OTP.");
  let destination: OnboardingDestination;
  if (details.employeeType === "SQELABS") {
    destination = "regular-india";
  } else if (details.employeeType === "REGULAR") {
    destination = (details.onboardingFor ? details.onboardingFor === "US" : regularUsLink) ? "regular-us" : "regular-india";
  } else if (details.recipientType === "AGENCY" && details.consultantType === "VENDOR_BASED") {
    destination = "agency";
  } else if (details.recipientType === "CONSULTANT") {
    switch (details.consultantType) {
      case "INDIAN_CONSULTANT": destination = "consultant-india"; break;
      case "DIRECT": destination = "consultant-us"; break;
      case "VENDOR_BASED": destination = "consultant-agency-us"; break;
      default: throw new Error("This consultant invitation type is not supported. Please contact your onboarding coordinator.");
    }
  } else {
    throw new Error("This invitation does not identify a supported recipient. Please contact your onboarding coordinator.");
  }
  return { destination, details };
}
